export enum PortfolioAlertsTypes {
    issuanceMonitorAlert = 'issuanceMonitorAlert',
    bwicAlert = 'bwicAlert',
    dealersInventoryAlert = 'dealersInventoryAlert',
    rollerDeadlineAlert = 'rollerDeadlineAlert',
}
